export enum ApplicationErrors {
  SESSION_ALREADY_IN_USE,
  CREDENTIALS_ERROR
}
